const formatPathString = (path: string, obj = {}) => {
  const pathString = Object.entries(obj).reduce((acc, [key, value]) => acc.replace(`:${key}`, value as string), path)

  return pathString
}

const formatQueryString = (obj = {}) => {
  const queryString = Object.keys(obj)
    .map(key => `${key}=${obj[key]}`)
    .join('&')

  return queryString ? `?${queryString}` : ''
}

const buildPath = (path, params, queryParams) => {
  const pathString = formatPathString(path, params)
  const queryString = formatQueryString(queryParams)

  return pathString + queryString
}

export { formatPathString, formatQueryString, buildPath }
